var $ = require('jquery');
var forms = require('./forms')

$(function () {
    var ctaBlockSelector = ".ws-cta-block";
    var $ctaBlock = $(ctaBlockSelector);
    var ctaBlockWrapperFormClass = "ws-cta-block__wrapper--form";
    var ctaBlockWrapperSelector = ".ws-cta-block__wrapper";
    var $ctaBlockWrapper = $(ctaBlockWrapperSelector);
    var ctaBlockFormHiddenClass = "ws-cta-block__form--hidden";
    var ctaBlockFormSelector = ".ws-cta-block__form";
    var ctaBlockIconFormClass = "ws-cta-block__icon--form";
    var ctaBlockFormSuccessClass = "ws-cta-block__form-success";
    var ctaBlockIconSelector = ".ws-cta-block__icon";
    var ctaBlockFormCloseSelector = ".ws-cta-block__form-close";
    var ctaBlockFormHeaderSelector = ".ws-cta-block__form-heading";
    var ctaBlockContentSelector = ".ws-cta-block__content";
    var ctaBlockCtaSelector = ".ws-cta-block__cta";
    var dialogMaskSelector = ".ws-dialog__mask";
    var maskEnabledClass = "ws-dialog__mask--enabled";
    var dialogVisibleClass = "ws-dialog__mask--visible";


    var ctaBlockWidth = 0;
    var ctaBlockHeight = 0;
    var topPosition = 0;
    var leftPosition = 0;


    function toggleForm(currentCtaBlock) {
        currentCtaBlock.find(ctaBlockWrapperSelector).toggleClass(ctaBlockWrapperFormClass);
        currentCtaBlock.find(ctaBlockFormSelector).toggleClass(ctaBlockFormHiddenClass);
        currentCtaBlock.find(ctaBlockIconSelector).toggleClass(ctaBlockIconFormClass);
        currentCtaBlock.find(ctaBlockFormCloseSelector).toggleClass(ctaBlockFormHiddenClass);
        currentCtaBlock.find(ctaBlockFormHeaderSelector).toggleClass(ctaBlockFormHiddenClass);
        currentCtaBlock.find(ctaBlockContentSelector).toggle();
        currentCtaBlock.find(ctaBlockCtaSelector).toggle();
        $(dialogMaskSelector).toggleClass(maskEnabledClass);
        $(dialogMaskSelector).toggleClass(dialogVisibleClass);
    }

    function closeForm(currentCtaBlock) {
        var $currentCtaBlock = currentCtaBlock;
        if ($currentCtaBlock.find(ctaBlockFormSelector).children().length) {
            var $currentWrapper = $currentCtaBlock.find(ctaBlockWrapperSelector);
            $currentWrapper.css({ "position": "fixed", "top": topPosition, "left": leftPosition, width: ctaBlockWidth, height: ctaBlockHeight });
            setTimeout(function () {
                $currentWrapper.css({ "position": "", "top": "", "left": "", width: "" });
                $currentCtaBlock.css({ height: "", "z-index": "" });
            }, 100)
            $('body').css({ "overflow": "" });
            $ctaBlock.each(function () {
                if ($(this).find(ctaBlockWrapperSelector).hasClass(ctaBlockWrapperFormClass)) {
                    toggleForm($(this));
                }
            });
            $(ctaBlockFormSelector).each(function () {
                var $formContent = $(this).find('.ws-content--custom-form');
                forms.resetForm($formContent);
            });
        }
    }

    function displaySuccess(currentCtaBlock) {
        var $currentCtaBlock = currentCtaBlock;
        if ($currentCtaBlock.find(ctaBlockFormSelector).children().length) {
            var $currentWrapper = $currentCtaBlock.find(ctaBlockWrapperSelector);
            $currentWrapper.css({ "position": "fixed", "top": topPosition, "left": leftPosition, width: ctaBlockWidth, height: $currentCtaBlock.height() });
            setTimeout(function () {
                $currentWrapper.css({ "position": "", "top": "", "left": "", width: "", height: "" });
                $currentCtaBlock.css({ height: "", "z-index": "" });
            }, 100)
            $('body').css({ "overflow": "" });
            if ($currentWrapper.hasClass(ctaBlockWrapperFormClass)) {
                currentCtaBlock.find(ctaBlockWrapperSelector).toggleClass(ctaBlockWrapperFormClass);
                currentCtaBlock.find(ctaBlockFormSelector).toggleClass(ctaBlockFormSuccessClass);
                $(dialogMaskSelector).toggleClass(maskEnabledClass);
                $(dialogMaskSelector).toggleClass(dialogVisibleClass);
                $(ctaBlockIconSelector).hide();
            }
        }
    }

    function closeOpenForms() {
        $ctaBlock.each(function () {
            if ($(this).find(ctaBlockWrapperSelector).hasClass(ctaBlockWrapperFormClass)) {
                closeForm($(this));
            }
        });
    }

    $(ctaBlockCtaSelector).on('click', function (event) {
        var $currentCtaBlock = $(event.target).closest(ctaBlockSelector);
        if ($currentCtaBlock.find(ctaBlockFormSelector).children().length) {
            //Stop link follow to display form instead
            event.preventDefault();
            //Open the form on the clicked CTA block
            var $currentWrapper = $currentCtaBlock.find(ctaBlockWrapperSelector);
            leftPosition = ($currentWrapper.offset().left);
            topPosition = ($currentWrapper.offset().top - $(window).scrollTop());
            ctaBlockHeight = $currentWrapper.height();
            $currentCtaBlock.css({ height: $currentCtaBlock.height() + "px", 'z-index': 10000 });
            //Setting initial wrapper position so that animations takes place from original CTA Block position
            $currentWrapper.css({ "position": "fixed", "top": topPosition, "left": leftPosition, height: $currentWrapper.height(), width: $currentWrapper.width() });
            ctaBlockWidth = $currentWrapper.width();
            $('body').css({ "overflow": "hidden" });
            toggleForm($currentCtaBlock);
            if (window.innerWidth > 991) {
                $currentWrapper.css({ "position": "", "top": "", "left": "", height: "", width: ctaBlockWidth });
            }
            else {
                $currentWrapper.css({ "position": "", "top": "", "left": "", height: "", width: "" });
            }
            var sectionItem = ctaBlockFormSelector + " .ws-section__item";
            if ($(sectionItem).height() > 515) {
                $(ctaBlockFormSelector).css({ "overflow-y": "auto" });
            }
        }
    });

    $('.ws-content--custom-form').on('formSuccess', function (e) {
        var $currentCtaBlock = $(e.target).closest(ctaBlockSelector);
        displaySuccess($currentCtaBlock);
    });

    $('.ws-cta-block__reset-form').on('click', function (e) {
        $('.ws-content--custom-form').on('formReset', function (e) {
            //Reset CTA Block to Original State
        });
    });


    $('.ws-cta-block__form-close').on('click', function (e) {
        $currentCtaBlock = $(e.target).closest(ctaBlockSelector);
        closeForm($currentCtaBlock);
    });

    $(document).on("click", function (e) {
        // close the form when the user clicks anywhere on the page, except within the form itself or the trigger element
        var selectors = '.ws-cta-block__form-close, .ws-cta-block__cta, .ws-cta-block__wrapper';
        if (!$(e.target).is(selectors) && !$(e.target).parents(selectors).length && $ctaBlockWrapper.hasClass('ws-cta-block__wrapper--form')) {
            closeOpenForms();
        }
    });

    $('.ws-cta').focus(function (event) {
        if ($(event.target).parents().hasClass('ws-cta-block__cta') && window.innerWidth > 1199) {
            var $currentCtaBlock = $(event.target).closest('.ws-cta-block');
            $currentCtaBlock.addClass('ws-cta-block__focused');
        }
    });
    $('.ws-cta').blur(function (event) {
        if ($(event.target).parents().hasClass('ws-cta-block__cta') && window.innerWidth > 1199) {
            var $currentCtaBlock = $(event.target).closest('.ws-cta-block');
            $currentCtaBlock.removeClass('ws-cta-block__focused');
        }
    });
});